import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-pcomp-bscontainer',
	templateUrl:'./BSContainerPluginCompPage.html',
	styles: [],
	styleUrls:['./BSContainerPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class BSContainerPluginCompPage
{
	mdContent_805 = `\`\`\`java
import com.jwebmp.plugins.bootstrap.containers.BSContainer;
\`\`\``;
	mdContent_806 = `\`\`\`java
BSContainer()
\`\`\``;
	mdContent_807 = `\`\`\`java
BSContainer(boolean fluid)
\`\`\``;
	mdContent_808 = `\`\`\`java
BSContainer&lt;?&gt; container = new BSContainer&lt;&gt;();
container.setFluid(true);
container.add(new BSRow&lt;&gt;());
\`\`\``;
}
